import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
export const getSelectedEls = (self) => {
  const selected_els = [];
  for (const id of self._selected_el_ids) {
    const el = self._els.get(id);
    if (el != null) {
      selected_els.push(el);
    }
  }
  return selected_els;
};
